import { render, staticRenderFns } from "./SignatureField.vue?vue&type=template&id=447882c2&scoped=true&"
import script from "./SignatureField.vue?vue&type=script&lang=js&"
export * from "./SignatureField.vue?vue&type=script&lang=js&"
import style0 from "./SignatureField.vue?vue&type=style&index=0&id=447882c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447882c2",
  null
  
)

export default component.exports